import React from 'react';

const AmbassadorNetworkIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M1143 4785 c-145 -32 -286 -139 -355 -271 -150 -285 -38 -631 248
       -766 66 -31 176 -58 239 -58 66 0 176 28 245 62 88 43 205 160 248 248 104
       212 67 459 -94 629 -132 141 -332 199 -531 156z"
        />
        <path
          d="M3755 4794 c-190 -40 -326 -138 -400 -287 -132 -269 -52 -567 196
       -727 274 -177 647 -71 788 223 61 126 74 229 46 362 -54 259 -279 438 -545
       434 -36 -1 -74 -3 -85 -5z"
        />
        <path
          d="M2415 3804 c-119 -13 -355 -68 -355 -83 0 -4 26 -33 58 -64 l59 -58
       104 22 c153 33 391 33 548 0 l113 -23 59 58 c32 32 59 61 59 65 0 9 -131 46
       -230 64 -84 16 -337 27 -415 19z"
        />
        <path
          d="M1720 3688 c-58 -50 -186 -113 -273 -133 -98 -23 -262 -21 -358 4
       -94 24 -206 79 -259 127 -50 46 -60 43 -171 -40 -147 -111 -261 -248 -310
       -375 -17 -42 -23 -78 -23 -146 -1 -86 1 -95 37 -167 44 -89 92 -136 187 -182
       l65 -31 628 -3 c546 -2 636 -1 690 13 152 39 258 151 287 305 31 163 -82 384
       -276 541 -59 48 -134 101 -169 121 -5 3 -30 -12 -55 -34z"
        />
        <path
          d="M3284 3683 c-260 -173 -414 -412 -390 -606 15 -116 100 -238 203
       -290 90 -46 127 -48 788 -45 l620 3 63 29 c81 38 171 131 203 213 30 76 33
       206 6 273 -57 139 -215 322 -361 417 l-79 52 -43 -38 c-193 -169 -541 -203
       -785 -75 -38 20 -89 54 -112 75 l-44 38 -69 -46z"
        />
        <path
          d="M1065 2568 c-11 -31 -25 -191 -25 -280 0 -323 112 -655 308 -911 59
       -78 166 -191 222 -237 l36 -29 48 60 48 59 -93 93 c-200 198 -332 443 -384
       710 -31 155 -30 407 1 525 6 21 4 22 -75 22 -56 0 -83 -4 -86 -12z"
        />
        <path
          d="M3894 2558 c3 -13 11 -78 18 -146 40 -417 -118 -822 -442 -1128 l-54
       -52 26 -33 c15 -19 38 -47 51 -64 l25 -30 114 115 c245 248 388 538 433 877
       17 128 19 235 5 358 -15 134 -8 125 -102 125 -78 0 -80 -1 -74 -22z"
        />
        <path
          d="M2428 2365 c-133 -34 -251 -117 -327 -231 -64 -96 -92 -183 -93 -294
       -3 -165 46 -284 162 -400 41 -42 98 -88 127 -103 65 -34 190 -67 257 -67 139
       1 298 64 393 158 97 96 149 214 159 362 18 259 -126 478 -368 561 -81 28 -229
       35 -310 14z"
        />
        <path
          d="M1979 1249 c-180 -123 -342 -333 -369 -478 -30 -159 65 -338 219
       -414 l66 -32 665 0 665 0 67 33 c78 38 144 106 185 190 25 51 28 67 28 162 0
       102 -1 107 -38 175 -51 95 -124 190 -202 263 -60 57 -166 135 -199 148 -8 3
       -37 -13 -67 -36 -123 -97 -261 -142 -439 -143 -174 -1 -315 45 -438 142 -28
       23 -55 41 -60 41 -5 0 -42 -23 -83 -51z"
        />
      </g>
    </svg>
  );
};

export default AmbassadorNetworkIcon;
